<div class="card">
    <form [formGroup]="profileForm" (keyup.enter)="submit.focus(); save()" *ngIf="profileLoaded">
      <div class="col-wrap">
        <div class="col">
          <app-form-profile-picture-upload 
            *ngIf="displayField(profileField.PICTURE)"
            label="{{'pages.profile.profilePictureButton' | translate }}" 
            formControlName="picture"
            data-cy="picture">
            <app-form-error *ngIf="picture.touched && picture.hasError('required')">
              {{'common.errors.invalidProfilePicture' | translate }}
            </app-form-error>
          </app-form-profile-picture-upload>
          <app-form-input 
             *ngIf="displayField(profileField.FIRSTNAME)"
            label="{{'common.fields.firstName' | translate }}" 
            formControlName="firstName"
            data-cy="firstName">
            <app-form-error *ngIf="firstName.touched && firstName.hasError('required')">
              {{'common.errors.invalidFirstName' | translate }}
            </app-form-error>
          </app-form-input>
          <app-form-input 
            *ngIf="displayField(profileField.LASTNAME)"
            label="{{'common.fields.lastName' | translate }}" 
            formControlName="lastName" 
            data-cy="lastName">
            <app-form-error *ngIf="lastName.touched && lastName.hasError('required')">
              {{'common.errors.invalidLastName' | translate }}
            </app-form-error>
          </app-form-input>
          <app-form-datepicker
            *ngIf="displayField(profileField.BIRTHDATE)"
            label="{{'common.fields.birthdate' | translate }}" 
            formControlName="birthDate"
            [max]="maxDate"
            data-cy="birthDate">
            <app-form-error *ngIf="birthDate.touched">
              <div *ngIf="birthDate.hasError('validateDateIsInPast')">
                {{'common.errors.birthDateFuture' | translate }}
              </div>
              <div *ngIf="birthDate.hasError('required')">
                {{'pages.profile.errors.required.birthDate' | translate }}
              </div>
            </app-form-error>
          </app-form-datepicker>
          <div class="radio-wrap"
          *ngIf="displayField(profileField.SEX)">
            <label>{{'common.fields.sex' | translate }}</label>
            <app-form-radio
              val="male"
              formControlName="sex" 
              data-cy="male">
              {{'pages.profile.male' | translate }}
            </app-form-radio>
            <app-form-radio
              val="female"
              formControlName="sex"
              data-cy="female">
              {{'pages.profile.female' | translate }}
            </app-form-radio>
            <app-form-radio
              *ngIf="orgTag !== 'BROSSARD'"
              val="other"
              formControlName="sex"
              data-cy="other">
              {{'pages.profile.other' | translate }}
            </app-form-radio>
            <app-form-error class="small-text" *ngIf="sex.touched && sex.hasError('required')">
              {{'pages.profile.errors.invalidSex' | translate }}
            </app-form-error>
          </div>
        </div>
        <div class="col">
          <app-form-input
            *ngIf="displayField(profileField.PHONE)"
            appPhoneMask
            type="phone" 
            label="{{'common.fields.mainPhone' | translate}}" 
            formControlName="phone"
            data-cy="phone">
            <app-form-error *ngIf="phone.touched">
              <div *ngIf="phone.hasError('minlength') || phone.hasError('maxlength')">
                {{'pages.profile.errors.invalidPhoneNumber' | translate }}
              </div>
              <div *ngIf="phone.hasError('required')">
                {{'pages.profile.errors.required.phone' | translate }}
              </div>
            </app-form-error>
          </app-form-input>
          <div class="phone-ext" *ngIf="displayField(profileField.SECPHONE)">
            <app-form-input appPhoneMask label="{{ 'common.fields.secondaryPhone' | translate }}" formControlName="secPhone" data-cy="secPhone" type="phone">
                <app-form-error *ngIf="secPhone.touched">
                    <div *ngIf="secPhone.errors && (secPhone.errors.minlength || secPhone.errors.maxlength)">
                        {{'pages.profile.errors.invalidPhoneNumber' | translate }}
                    </div>
                </app-form-error>
            </app-form-input>
            <app-form-input [disabled]="!secPhone.valid || !secPhone.value" label="{{ 'common.fields.extPhone' | translate }}" formControlName="secPhoneExt" data-cy="secPhoneExt">
            </app-form-input>
          </div>  
          <app-form-input 
            *ngIf="displayField(profileField.CELLPHONE)"
            appPhoneMask
            type="phone" 
            label="{{ 'common.fields.cellphone' | translate }}" 
            formControlName="cellPhone"
            data-cy="cellPhone">
            <app-form-error *ngIf="cellPhone.touched">
              <div *ngIf="cellPhone.errors && (cellPhone.errors.minlength || cellPhone.errors.maxlength)">
                {{'pages.profile.errors.invalidPhoneNumber' | translate }}
              </div>
            </app-form-error>
          </app-form-input>
          <div class="input-button-container">
            <app-confirm-form-input
            *ngIf="displayField(profileField.EMAIL)"
            label="{{ 'common.fields.primaryEmail' | translate }}"
            formControlName="email"
            data-cy="email"
            type="email"
            [changeInput]="changeEmail"
            [previousInput]="originalEmail"
            [placeholder]="emailBeingCleared ? '' : ('pages.profile.emptyEmail' | translate)">
          </app-confirm-form-input>
        </div>
          <div *ngIf="emailBeingCleared" class="email-clear-warning">
            <span class="icon-warning"></span>
            {{ 'pages.profile.emailWillBeEmpty' | translate }}
          </div>
          <div *ngIf="changeEmail && !emailBeingCleared" class="confirm-email-wrap">
             <app-form-input
               class="span"
               type="email"
               label="{{ 'common.fields.confirmEmail' | translate }}"
               formControlName="confirmEmail"
               data-cy="confirmEmail"
               *ngIf="displayField(profileField.EMAIL)"
             >
             <app-form-error *ngIf="email.touched &&  email.value != confirmEmail.value">
               {{ 'common.errors.invalidConfirmEmail' | translate }}
             </app-form-error>
           </app-form-input>
          </div>
        </div>
      </div>
    </form>

    <!-- Addresses Section -->
    <div class="addresses-section" *ngIf="profileLoaded">
      <h4 class="section-title">{{ 'pages.profile.addresses.title' | translate }}</h4>
      <div class="addresses-grid">
        <div class="address-card" *ngFor="let pa of profileAddresses; let i = index">
          <!-- Top row: name + badges/verify -->
          <div class="address-card-header">
            <div class="address-name-row">
              <span class="address-name">{{ pa.displayName | uppercase }}</span>
              <i class="icon-edit address-edit-icon"
                *ngIf="!pa.isCasual"
                [matMenuTriggerFor]="editMenu"></i>
              <mat-menu #editMenu="matMenu">
                <button mat-menu-item (click)="renameResidence(pa)">
                  <i class="icon-edit"></i>
                  {{ 'pages.profile.addresses.renameTitle' | translate }}
                </button>
                <button mat-menu-item (click)="editResidenceAddress(pa)">
                  <i class="icon-map"></i>
                  {{ 'pages.profile.addresses.editAddress' | translate }}
                </button>
                <button mat-menu-item *ngIf="pa.orgLinks[0]?.subType" (click)="openChangeSubTypeDialog(pa)">
                  <i class="icon-home"></i>
                  {{ 'pages.profile.addresses.changeSubType' | translate }}
                </button>
              </mat-menu>
            </div>
            <div class="address-header-right">
              <button
                *ngIf="pa.isCasual"
                class="verify-btn"
                (click)="verifyAddress(pa)">
                {{ 'pages.profile.addresses.verifyAddress' | translate }}
              </button>
              <div class="address-badges" *ngIf="pa.orgLinks.length > 0 || pa.isCasual">
                  <span *ngIf="i === 0" class="badge badge--primary">
                    <i class="icon-home"></i>
                    {{ 'pages.profile.addresses.primaryResidence' | translate }}
                  </span>
                  <span *ngIf="pa.orgLinks[0]?.displayState === 'active'" class="badge badge--verified">
                    <i class="icon-check"></i>
                    {{ 'pages.profile.addresses.active' | translate }}
                  </span>
                  <span *ngIf="pa.orgLinks[0]?.displayState === 'pending'" class="badge badge--pending">
                    {{ 'pages.profile.addresses.pending' | translate }}
                  </span>
                  <button
                    *ngIf="pa.orgLinks[0]?.displayState === 'rejected'"
                    class="verify-btn"
                    (click)="reviewResidence(pa)">
                    {{ 'pages.profile.addresses.verifyAddress' | translate }}
                  </button>
                  <span *ngIf="pa.orgLinks[0]?.displayState === 'rejected'" class="badge badge--rejected">
                    {{ 'pages.profile.addresses.rejected' | translate }}
                  </span>
                  <span *ngIf="pa.orgLinks[0]?.displayState === 'expiring_soon'" class="badge badge--expiring">
                    {{ 'pages.profile.addresses.expiringSoon' | translate }}
                  </span>
                  <span *ngIf="pa.orgLinks[0]?.displayState === 'expired'" class="badge badge--rejected">
                    {{ 'pages.profile.addresses.expired' | translate }}
                  </span>
                  <span *ngIf="pa.orgLinks[0]?.displayState === 'renewal_pending'" class="badge badge--pending">
                    {{ 'pages.profile.addresses.renewalPending' | translate }}
                  </span>
                  <span *ngIf="pa.orgLinks[0]?.subType === 'RESIDENT'" class="badge badge--subtype-resident">
                    {{ 'pages.residences.subType.resident' | translate }}
                  </span>
                  <span *ngIf="pa.orgLinks[0]?.subType === 'NONRESIDENT'" class="badge badge--subtype-nonresident">
                    {{ 'pages.residences.subType.nonResident' | translate }}
                  </span>
                <span *ngIf="pa.isCasual" class="badge badge--unverified">
                  {{ 'pages.profile.addresses.unverified' | translate }}
                </span>
              </div>
            </div>
          </div>

          <!-- Address with location pin -->
          <div class="address-detail">
            <i class="icon-map address-pin"></i>
            <div class="address-lines">
              <span>{{ pa.address.unit ? '#' + pa.address.unit + ' ' : '' }}{{ pa.address.number }} {{ pa.address.streetName || pa.address.street }}</span>
              <span>{{ pa.address.city }}{{ pa.address.province ? ' (' + pa.address.province + ')' : '' }}</span>
              <span>{{ pa.address.postCode }}</span>
            </div>
          </div>

          <div class="expiration-info" *ngIf="pa.orgLinks[0]?.expirationDate">
            {{ 'pages.profile.addresses.expiresOn' | translate }}: {{ pa.orgLinks[0].expirationDate | date:'mediumDate' }}
          </div>

          <!-- Bottom actions with separator -->
          <div class="address-card-actions">
            <div class="actions-left">
              <button
                *ngIf="i !== 0"
                class="set-primary-btn"
                (click)="setMainAddress(pa)">
                {{ 'pages.profile.addresses.setAsMainAddress' | translate }}
              </button>
            </div>
            <button *ngIf="i !== 0" class="delete-address-btn" (click)="deleteAddress(pa)">
              <i class="icon-trash-bin"></i>
              {{ 'pages.profile.addresses.delete' | translate }}
            </button>
          </div>
        </div>
      </div>
      <button class="add-address-btn" (click)="openAddAddressDialog()">
        <span>+</span> {{ 'pages.profile.addresses.addAddress' | translate }}
      </button>
    </div>

    <div *ngIf="!profileLoaded" class="loading-spinner">
      <mat-progress-spinner
        mode="indeterminate"
        diameter="18">
      </mat-progress-spinner>
    </div>
    <footer>
      <button
        #submit
        class="bciti-button bciti-button--blue"
        [disabled]="loading || !profileLoaded"
        data-cy="save-button"
        (click)="save()">
        <span *ngIf="!loading">{{ 'pages.profile.save' | translate }}</span>
        <div *ngIf="loading" class="loading-spinner">
          <mat-progress-spinner
            mode="indeterminate"
            diameter="18">
          </mat-progress-spinner>
        </div>
      </button>
    </footer>
  </div>


  <ng-template #popTitle>
    {{ 'common.fields.primaryEmail' | translate }} <span class="icon-info"></span>
  </ng-template>